module.exports = __webpack_public_path__ + "static/media/logo_policiaCivil.5c3f1b87.png";